// @ts-nocheck
import React, { useEffect, useState, useRef } from 'react';
import {
  Flex,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Card,
  Button,
  Select, // Import Select component
} from '@chakra-ui/react';
import { FaCog } from 'react-icons/fa';
import AudioPlayer from './AudioPlayer'; // Ensure the correct path to your AudioPlayer component

const songs = [
  '/audio/Crypto Quest.mp3',
  '/audio/Cryptic-Candy.mp3',
  '/audio/Sweet-Crypto-Quest.mp3',
  '/audio/Sweet-Digital-Quest.mp3',
  '/audio/Cryptic-Candy2.mp3',
  '/audio/Sweet-Crypto-Quest2.mp3',
  '/audio/Sweet-Digital-Quest2.mp3',
  '/audio/Sweet-Tokens.mp3',
  '/audio/Sweet-Digital-Quest3.mp3',
  '/audio/Cryptic-Candy3.mp3',
  '/audio/Sweet-Tokens2.mp3',
  '/audio/Subterranean-Beats.mp3',
  '/audio/Cryptic-Candy4.mp3',
  '/audio/Crypto Quest2.mp3',
  '/audio/Sweet-Digital-Quest4.mp3',
];

const SettingsMenu = ({ onReset, onOpenLevelModal }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isPlaying, setIsPlaying] = useState(true); // Set initial state to true to play the audio.
  const [volume, setVolume] = useState(60);
  const [isMuted, setIsMuted] = useState(false);
  const [currentSongIndex, setCurrentSongIndex] = useState(0);
  const audioRef = useRef(null);

  const handleSongChange = (event) => {
    const selectedIndex = parseInt(event.target.value);
    setCurrentSongIndex(selectedIndex);
  };

  useEffect(() => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.play();
      } else {
        audioRef.current.pause();
      }
      audioRef.current.muted = isMuted;
      audioRef.current.volume = volume / 100;
    }
  }, [isPlaying, isMuted, volume, currentSongIndex]);

  useEffect(() => {
    const modalContent = document.querySelector('.modal-content');
    modalContent?.classList.add('fade-in');
  }, [isOpen]);

  return (
    <>
      <IconButton icon={<FaCog style={{ color: 'blue' }} />} aria-label="Settings" onClick={onOpen} />
      <audio
        ref={audioRef}
        src={songs[currentSongIndex]}
        autoPlay={isPlaying}
        loop={false}
        onEnded={() => {
          const nextIndex = (currentSongIndex + 1) % songs.length;
          setCurrentSongIndex(nextIndex);
        }}
      />
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          p={2}
          borderRadius="10px"
          bg="white"
          width="200px"
          height="350px"
          className="custom-modal"
        >
          <ModalHeader textAlign="center" color="blue">Settings</ModalHeader>
          <ModalCloseButton color="red" />
          <ModalBody>
            <Flex justifyContent="center" alignItems="center" flexDirection="column">
              <Card className='card' width="100%" height="150%" p={1}>
                <Select
                  value={currentSongIndex}
                  onChange={handleSongChange}
                  placeholder="Select a song"
                  variant="filled"
                  size="md"
                  bg="red.700"
                  color="white"
                  _hover={{ bg: "red.500" }}
                  _focus={{ borderColor: "teal.400", boxShadow: "0 0 0 1px teal.400" }}
                  borderRadius="md"
                  mb={4} // margin-bottom
                >
                  {songs.map((song, index) => (
                    <option key={index} value={index}>
                      {song.split('/').pop().replace('.mp3', '')}
                    </option>
                  ))}
                </Select>
                <AudioPlayer
                  isPlaying={isPlaying}
                  setIsPlaying={setIsPlaying}
                  volume={volume}
                  setVolume={setVolume}
                  isMuted={isMuted}
                  setIsMuted={setIsMuted}
                  currentSongIndex={currentSongIndex}
                  setCurrentSongIndex={setCurrentSongIndex}
                  songs={songs}
                />
                <Button colorScheme="teal" onClick={() => onOpenLevelModal(true)}>
                  Open Level Modal
                </Button>
                
              </Card>
            </Flex>
          </ModalBody>
          <ModalFooter />
        </ModalContent>
      </Modal>
      <style jsx global>{`
        .custom-modal {
          position: absolute !important;
          top: -50% !important;
          left: 50% !important;
          transform: translate(-50%, 50%) !important;
        }
      `}</style>
    </>
  );
};

export default SettingsMenu;
